export interface ActiveCartReference {
  resourceId: string;
}

export type EnsureActiveCart = () => Promise<ActiveCartReference>;

let ensureActiveCart: EnsureActiveCart | undefined;

export function configureActiveCartPort(ensure: EnsureActiveCart): void {
  ensureActiveCart = ensure;
}

export function ensureActiveCartForContext(): Promise<ActiveCartReference> {
  if (!ensureActiveCart) {
    return Promise.reject(new Error("Active Cart port has not been configured"));
  }
  return ensureActiveCart();
}
